import { stats } from "@/src/lib/logging/stats.server";

/**
 * Wraps an async function with performance monitoring.
 *
 * @param fn - The async function to wrap.
 * @param metricName - The name of the metric to track.
 * @returns The wrapped function with the same signature and return type.
 */
export function withDurationMetric<T extends (...args: any[]) => Promise<any>>(
  fn: T,
  metricName: string
): (...args: Parameters<T>) => Promise<Awaited<ReturnType<T>>> {
  return async (...args: Parameters<T>) => {
    const start = performance.now();
    const result = await fn(...args);
    const end = performance.now();

    // Find group ID from any argument that has a group property
    const groupId = args.find((arg) => arg?.group?.id)?.group?.id;

    stats.histogram(`${metricName}.duration`, end - start, {
      tags: {
        method: fn.name || "anonymous",
        groupId: groupId,
      },
    });

    return result;
  };
}
